$(document).ready(function() {
  $('.cc__featured-testimionial').slick({
    autoplay: true
  });

  $('.cc__inputs label').click(function(){
    var label = $(this).find('.cc__variants-color-swatch').data('color');
    var variant = $(this).find('.cc__variants-color-swatch').data('variant');
    
    $('.form__option').text(label);
    //$('.cc__inputs input').prop('checked', false);
    //$('.cc__inputs input').removeAttr('checked');
    //$('.cc__inputs input[value="' + label + '"]').prop('checked', true);
    //$('.cc__inputs input[value="' + label + '"]').attr('checked', true);
    $('.cc__optionswatchcolor').removeClass('cc__activeoptions');
    $('.cc__currentoptionswatchitemcurr').html($('.cc__inputcolorswatch[title="' + label + '"]').html());

    $('#ProductInfo-cc-stickyatc .form.product-submit input[name="id"]').val(variant);
    $('#ProductInfo-cc-stickyatc .form.product-submit input[name="id"]').prop('value', variant);
    $('#ProductInfo-cc-stickyatc .form.product-submit input[name="id"]').attr('value', variant);
  });
});